import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { get } from "lodash";
import setting from "@/setting.js";
export default {
  namespaced: true,
  state: {
    // 主题
    list: get(setting, "theme.list", []),
    // 现在激活的主题 这应该是一个名字 不是对象
    activeName: get(setting, "theme.list[0].name", "d2")
  },
  getters: {
    /**
     * @description 返回当前的主题信息 不是一个名字 而是当前激活主题的所有数据
     * @param {Object} state state
     */
    activeSetting: function activeSetting(state) {
      return state.list.find(function (theme) {
        return theme.name === state.activeName;
      });
    }
  },
  actions: {
    /**
     * @description 激活一个主题
     * @param {String} themeValue 需要激活的主题名称
     */
    set: function set(_ref, themeName) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state, commit, dispatch;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
              // 检查这个主题在主题列表里是否存在
              state.activeName = state.list.find(function (e) {
                return e.name === themeName;
              }) ? themeName : state.list[0].name;
              // 将 vuex 中的主题应用到 dom
              commit("dom");
              // 持久化
              _context.n = 1;
              return dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "theme.activeName",
                value: state.activeName,
                user: true
              }, {
                root: true
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * @description 从持久化数据加载主题设置     * @param {Object} context
     */
    load: function load(_ref2) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var state, commit, dispatch, activeName;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              state = _ref2.state, commit = _ref2.commit, dispatch = _ref2.dispatch;
              _context2.n = 1;
              return dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "theme.activeName",
                defaultValue: state.list[0].name,
                user: true
              }, {
                root: true
              });
            case 1:
              activeName = _context2.v;
              if (!state.list.find(function (e) {
                return e.name === activeName;
              })) {
                _context2.n = 2;
                break;
              }
              state.activeName = activeName;
              _context2.n = 3;
              break;
            case 2:
              state.activeName = state.list[0].name;
              // 持久化
              _context2.n = 3;
              return dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "theme.activeName",
                value: state.activeName,
                user: true
              }, {
                root: true
              });
            case 3:
              // 将 vuex 中的主题应用到 dom
              commit("dom");
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  mutations: {
    /**
     * @description 将 vuex 中的主题应用到 dom
     * @param {Object} state state
     */
    dom: function dom(state) {
      document.body.className = "theme-".concat(state.activeName);
    }
  }
};